<template>
    <template v-if="loading">
        <van-loading></van-loading>
    </template>
    <template v-else>
        <template v-if="deviceId">
            <h4>注册/登录</h4>
            <Form>
                <Field readonly="readonly" :model-value="deviceId" label="设备号" placeholder="设备号"/>
                <Field v-model="userName" required placeholder="输入用户名" label="用户名"/>
                <Field type="tel" required v-model="mobile" placeholder="输入手机号" label="手机号"/>
                <Field type="password" required v-model="password" placeholder="输入密码" label="密码"/>
              <Field v-model="shareToken" placeholder="邀请码" label="输入邀请码"/>
                <div class="button-wrap">
                  <p class="text-danger">请牢记你的用户名、手机号、密码!!!</p>
                  <Button type="primary" @click="doRegister">注册&nbsp;/&nbsp;登录</Button>&nbsp;
                </div>
            </Form>
        </template>
        <template v-else>
            <p class="van-color-warning van-error">未获取到设备号</p>
        </template>
    </template>
</template>
<style lang="less">
.button-wrap{
    margin-top: 1rem;
    margin-bottom: 1rem;
}
</style>

<script>
import store from "@/store";
import {Button, Field, Form, showNotify, Space} from "vant";
import {onMounted, ref, watch} from 'vue';
import {useRouter} from "vue-router"
import { format } from 'date-fns';
import {getUrlParam,reportError} from "@/utils/util";
import API from '@/api'

export default {
    name: 'UseRegister',
    components:{Form,Field,Button,Space},
    setup(){
        const loading = ref(true);
        const userStore = store.userStore();
        const deviceId = userStore.getDeviceId();
        const router = useRouter();
        const shareToken = ref("");
        const routeTo = (path) => router.push(path)

        try {
            onMounted(async () => {
                watch(userStore.user, async (value) => {
                  const time = new Date().getTime();
                    const formattedDate = format(new Date(time + 7*24*60*60*1000), 'yyyy-MM-dd');
                    if(value.registered) {
                      if (userStore.user.dataAuthTime < formattedDate) {
                        await routeTo("/pay");
                      } else {
                        if(userStore.user.bizType === "family"){
                          await routeTo("/family-config");
                        }else if(userStore.user.bizType === "doumi"){
                          await routeTo("/doumi-config");
                        }else{
                          await routeTo("/data-desc");
                        }

                      }
                    }
                });

                watch(userStore, async (value) => {
                    loading.value = value.loading;
                });

                const res = await API.share.getShareToken();
                if(res.success){
                  shareToken.value = res.data;
                }
            });
        } catch (e) {
            console.error(e);
        }

        const userName = ref('');
        const password = ref('');
        const mobile = ref('');

        return {
            userName,
            password,
            mobile,
            deviceId,
            shareToken,
            user: userStore.user,
            loading: loading,
            routeTo
        }
    },
    methods:{
        async doRegister(){
            const userStore = store.userStore();

            const res = await userStore.doRegister({
                  deviceId: this.deviceId
                , userName: this.userName
                , password : this.password
                , mobile: this.mobile
                , shareFromToken: this.shareToken
            });

            if(res.success){
                const expired = res.data.user.dataAuthTime < format(new Date(), 'yyyy-MM-dd H:mm:ss');
                if(expired){
                  this.routeTo("/pay");
                }
            }else{
                showNotify({type:"warning", message: res.errorMsg});
            }
        }
    }
}
</script>
